"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

require("../../util/GlobalScript.js");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactDnd = require("react-dnd");

var _classnames2 = _interopRequireDefault(require("classnames"));

var _underscore = _interopRequireDefault(require("underscore"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; (0, _forEach.default)(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context3; (0, _forEach.default)(_context3 = ownKeys(Object(source))).call(_context3, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

"use strict";

var TYPE = "DragDrop";
var dragSpec = {
  beginDrag: function beginDrag(props, monitor, component) {
    //eslint-disable-line
    props.onDragStart && props.onDragStart(); //eslint-disable-line

    return {
      id: props.id,
      index: props.index,
      column: props.column
    };
  },
  endDrag: function endDrag(props, monitor, component) {
    //eslint-disable-line
    props.onDragEnd && props.onDragEnd(); //eslint-disable-line
    // pass the value that indicates if item was dropped outside of container

    if (props.id === monitor.getItem().id && props.onCancel) {
      props.onCancel(monitor.didDrop());
    }
  },
  canDrag: function canDrag(props) {
    return !props.disabled;
  }
};

var dragCollect = function dragCollect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
};

var isInTopHalf = function isInTopHalf(monitor, node, dragToEdge) {
  var boundingRect = node.getBoundingClientRect();

  var _ref = monitor.getClientOffset() || {},
      _ref$y = _ref.y,
      y = _ref$y === void 0 ? 0 : _ref$y;

  var ownMiddleY = (boundingRect.bottom - boundingRect.top) / 2;
  return y - boundingRect.top <= ownMiddleY * (dragToEdge ? 2 : 1);
};

var isInLeftHalf = function isInLeftHalf(monitor, node, dragToEdge) {
  var boundingRect = node.getBoundingClientRect();
  var clientOffset = monitor.getClientOffset();
  var ownMiddleX = (boundingRect.right - boundingRect.left) / 2;
  return clientOffset.x - boundingRect.left <= ownMiddleX * (dragToEdge ? 2 : 1);
};

function handleDragEvent(callback, props, monitor, component) {
  var renderedNode = _reactDom.default.findDOMNode(component);

  var itemBeingDragged = monitor.getItem();
  var locationType = props.type === "column" ? isInLeftHalf : isInTopHalf;
  var offset = locationType(monitor, renderedNode, props.dragToEdge) ? 0 : 1;

  if (props[callback]) {
    props[callback](props.index + offset, itemBeingDragged.index, props.column, itemBeingDragged.column, props.id, itemBeingDragged.id);
  }

  if (component.state && component.state.dropAfter !== offset) {
    // setting a state property on the DragDropContainer
    // provides it as a prop in the DragDrop component
    component.setState({
      dropAfter: offset
    });
  }
}

var dropSpec = {
  /*
   * @param {object} props - the properties of the target row
   * @param {object} monitor - the monitor object:
   *  - monitor.getItem() will return the row being dragged
   *  - monitor.getClientOffset() will return the mouse position.
   * @param {object} component - the target row react instance
   * @returns null - nothing
   */
  hover: (0, _bind.default)(handleDragEvent).call(handleDragEvent, null, "onDrag"),
  drop: (0, _bind.default)(handleDragEvent).call(handleDragEvent, null, "onDrop")
};

var dropCollect = function dropCollect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    dropTarget: monitor.isOver()
  };
};
/**
 * @callback DragDrop~onDrag
 * @param {number} targetIndex
 *          current target index where items is dragged over or dropped
 * @param {number} sourceIndex
 *          origin index item is dragged or dropped from
 */

/**
 * @callback DragDrop~onDrop
 * @param {number} targetIndex
 *          current target index where items is dragged over or dropped
 * @param {number} sourceIndex
 *          origin index item is dragged or dropped from
 */

/**
 * @callback DragDrop~onCancel
 */

/**
 * @class DragDrop
 *
 * @desc A component to hide the workings of react-dnd.  Can be dragged on dropped onto any other component
 * of type DragDrop
 *
 * @param {string|number} id
 *          An id for the row
 * @param {number} index
 *          The index number for the row
 * @param {bool} [disabled=false]
 *          If child content should not be draggable. False by default (draggable).
 * @param {boolean} removeDraggableAttribute
 *          Remove the draggable="true" attribute to disable dragging.  This is useful to resolve issues with IE
 *          and input fields.
 * @param {DragDrop~onDrag} onDrag
 *          A callback which is execute when the row is moved.  Must have signature function (targetIndex, ownIndex)
 * @param {DragDrop~onDrop} onDrop
 *          A callback which is execute when the row is dropped.  Must have signature function (targetIndex, ownIndex)
 * @param {DragDrop~onDrag} onDragStart
 *          A callback fired when dragging starts. Different from onDrag as this is tied to the dragged object itself rather than being fired when over a droppable area.
 * @param {DragDrop~onDrag} onDragEnd
 *          A callback fired when dragging starts. Different from onDrop as this is tied to the dragged object itself rather than being fired when over a droppable area.
 * @param {DragDrop~onCancel} onCancel
 *          A callback which is executed when the dragging is cancelled (dropped outside a droppable area
 *          or esc button pressed).
 * @param {string} [type]
 *          String to specify whether the component is a row or a column. Default "row".
 * @param {string} [tagName]
 *          The DOM node to wrap the draggable component. Default "div"
 * @param {object} [style]
 *          Inline style object for child
 * @param {number} [dragToEdge=false]
 *          If true, the drag index will only increment when the drag location has passed the edge of the row instead
 *          of being incremented after the halfway mark which is the default behavior.
 * @example
 *
 *  <Draggable id={index} index={index} onDrag={this._onDrag} onDrop={this._onDrop}
 *              onCancel={this._onCancel} disabled={item === 2}>
 *      <div className={this._getDragClass(item, index)}>Row {item} {item === 2 && "can't drag me"}</div>
 *  </Draggable>
 *
 */


var DragDropBase = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(DragDropBase, _React$Component);

  var _super = _createSuper(DragDropBase);

  function DragDropBase() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, DragDropBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "state", {});
    return _this;
  }

  (0, _createClass2.default)(DragDropBase, [{
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props = this.props,
          className = _this$props.className,
          connectDragSource = _this$props.connectDragSource,
          connectDropTarget = _this$props.connectDropTarget,
          dataId = _this$props["data-id"],
          dropTarget = _this$props.dropTarget,
          isDragging = _this$props.isDragging;
      var opacity = this.props.isDragging ? 0.2 : 1;
      var draggingClass = className ? className + "--is-dragging" : "";
      var dropTargetClass = className ? className + "--drop-target" : "";
      var dropTargetAfterClass = className ? className + "--drop-target-after" : "";
      var rowProps = {
        className: (0, _classnames2.default)("drag-drop-item", className, (_classnames = {}, (0, _defineProperty3.default)(_classnames, draggingClass, isDragging), (0, _defineProperty3.default)(_classnames, dropTargetClass, dropTarget && !isDragging), (0, _defineProperty3.default)(_classnames, dropTargetAfterClass, dropTarget && !isDragging && this.props.dropAfter), _classnames)),
        "data-id": dataId,
        style: _objectSpread(_objectSpread({}, this.props.style), {}, {
          opacity: opacity
        })
      };

      var row = /*#__PURE__*/_react.default.createElement(this.props.tagName, rowProps, this.props.children); // IE must have a drop target even if dragging is disabled.  Enabling after the first render has no effect.


      return this.props.removeDraggableAttribute ? connectDropTarget(row) : connectDragSource(connectDropTarget(row));
    }
  }]);
  return DragDropBase;
}(_react.default.Component);

(0, _defineProperty3.default)(DragDropBase, "propTypes", {
  connectDragSource: _propTypes.default.func.isRequired,
  connectDropTarget: _propTypes.default.func.isRequired,
  isDragging: _propTypes.default.bool.isRequired,
  dropTarget: _propTypes.default.bool.isRequired,
  "data-id": _propTypes.default.string,
  id: _propTypes.default.any.isRequired,
  index: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
  onDrag: _propTypes.default.func,
  onDrop: _propTypes.default.func,
  onCancel: _propTypes.default.func,
  onDragStart: _propTypes.default.func,
  onDragEnd: _propTypes.default.func,
  type: _propTypes.default.string,
  tagName: _propTypes.default.string,
  style: _propTypes.default.object,
  disabled: _propTypes.default.bool,
  removeDraggableAttribute: _propTypes.default.bool,
  dragToEdge: _propTypes.default.bool
});
(0, _defineProperty3.default)(DragDropBase, "defaultProps", {
  "data-id": "drag-drop-item",
  disabled: false,
  tagName: "div",
  onCancel: _underscore.default.noop,
  onDrag: _underscore.default.noop,
  onDragEnd: _underscore.default.noop,
  onDragStart: _underscore.default.noop,
  onDrop: _underscore.default.noop,
  dragToEdge: false
});
var DragDrop = (0, _reactDnd.DropTarget)(TYPE, dropSpec, dropCollect)((0, _reactDnd.DragSource)(TYPE, dragSpec, dragCollect)(DragDropBase));
DragDrop.dropSpec = dropSpec;
DragDrop.dragSpec = dragSpec;
DragDrop.isInTopHalf = isInTopHalf;
DragDrop.isInLeftHalf = isInLeftHalf;
var _default = DragDrop;
exports.default = _default;
module.exports = exports["default"];